import { render } from "./HiVaultFile.vue?vue&type=template&id=91c0f05a"
import script from "./HiVaultFile.vue?vue&type=script&lang=js"
export * from "./HiVaultFile.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__